import { Box } from "@chakra-ui/react";

export function RightHandleIcon({ width, height, ...props }: any) {
  return (
    <Box {...props}>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.750163"
          y="0.583323"
          width="15.8333"
          height="15.8333"
          rx="7.91667"
          stroke="#C5C7D0"
          stroke-width="0.833333"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.70553 4.87204C6.86825 4.70932 7.13207 4.70932 7.29479 4.87204L10.2353 7.81254C10.2398 7.81702 10.2443 7.82153 10.2488 7.82606C10.3294 7.90661 10.4166 7.9937 10.4803 8.07714C10.5548 8.17488 10.6351 8.31474 10.6351 8.5C10.6351 8.68526 10.5548 8.82512 10.4803 8.92286C10.4166 9.0063 10.3294 9.09339 10.2488 9.17394C10.2443 9.17847 10.2398 9.18298 10.2353 9.18747L7.29479 12.128C7.13207 12.2907 6.86825 12.2907 6.70553 12.128C6.54282 11.9652 6.54282 11.7014 6.70553 11.5387L9.64603 8.59821C9.68495 8.55929 9.71649 8.52772 9.74333 8.5C9.71649 8.47228 9.68495 8.44071 9.64603 8.40179L6.70553 5.46129C6.54282 5.29858 6.54282 5.03476 6.70553 4.87204Z"
          fill="#18191B"
        />
      </svg>
    </Box>
  );
}
